export default "__VITE_ASSET__DI0MJyy0__"